import type { OrganizationMembershipWithOrganization } from "@arbeidsark/shared"
import React from "react"

export const OrganizationMembershipContext =
  React.createContext<OrganizationMembershipWithOrganization | null>(null)
